import { createFileRoute } from '@tanstack/react-router';

import { HybridPowerRoute } from './-hybridPower/HybridPowerRoute.tsx';

export const Route = createFileRoute('/(app)/hybrid-power')({
  component: HybridPowerRoute,
});
